import { Box, BoxProps, ColorOptions, Icon, IconOptions, ImageProps, Spacer, Text, TextProps } from '@jfs/ui-new'
import { FC } from 'react'
import { useStores } from '../../data/store'
import { convertHexToRGBA } from '../../utils'
import { THEME_PADDING } from '../../utils/constants'

const EMIItem: FC<{ type: string; title: string; subTitle: string; onClick: () => void }> = ({
  type,
  title,
  subTitle,
  onClick,
}: {
  type: string
  title: string
  subTitle: string
  onClick: () => void
}) => {
  const { theme } = useStores((root) => ({
    theme: root.config.merchantTheme,
  }))

  const style = styles(theme)
  return (
    <Box {...style.container} onPress={onClick}>
      <Icon id={type as IconOptions} color={theme.brandColor as ColorOptions} size={20} />
      <Spacer direction="horizontal" size={22} />
      <Box>
        <Text {...style.title}>{title}</Text>
        <Spacer size={4} />
        <Text {...style.subTitle}>{subTitle}</Text>
      </Box>
    </Box>
  )
}

const styles = (theme: any) => ({
  container: {
    underlayColor: convertHexToRGBA(theme?.brandColor, 10) as ColorOptions,
    flexDirection: 'row',
    paddingHorizontal: THEME_PADDING.HORIZONTAL_PADDING,
    paddingVertical: 16,
    alignItems: 'center',
  } as BoxProps,
  imageView: {
    height: 32,
    width: 32,
  } as ImageProps,
  title: {
    fontSize: 14,
    fontWeight: '700',
    color: theme?.bodyTextColor as ColorOptions,
  } as TextProps,
  subTitle: {
    fontSize: 12,
    fontWeight: '700',
    color: convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions,
  } as TextProps,
})
export default EMIItem
